import { render, staticRenderFns } from "./CryptogramPage.vue?vue&type=template&id=dec60282&"
import script from "./CryptogramPage.vue?vue&type=script&lang=js&"
export * from "./CryptogramPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports